<template>
    <div>
      <patent-form  ref="patentForm"></patent-form>
      <context-menu ref="copyMenu"></context-menu>
      <b-modal id="patentTransactionReportDetailModal" centered size="xl" no-close-on-backdrop ref="patentTransactionReportDetailModal" :title=" $t('patentTransactionReportDetail.modal_title')" hide-footer>
        <div class="custom-search">
          <!--Row 1-->
          <b-row>
            <b-col>            
              <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('recordNo', 'record_no', $event.target.checked)">
                {{ $t('patentTransactionReportDetail.record_no') }}
              </b-form-checkbox>
            </b-col>
            <b-col>
              <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('title', 'title', $event.target.checked)">
                {{ $t('patentTransactionReportDetail.title') }}
              </b-form-checkbox>
            </b-col>
            <b-col>
              <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('titleEn', 'title_en', $event.target.checked)">
                {{ $t('patentTransactionReportDetail.title_en') }}
              </b-form-checkbox>
            </b-col>
            <b-col>
              <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('agent', 'agent', $event.target.checked)">
                {{ $t('patentTransactionReportDetail.agent') }}
              </b-form-checkbox>
            </b-col>
            <b-col>
              <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('owner', 'owner', $event.target.checked)">
                {{ $t('patentTransactionReportDetail.owner') }}
              </b-form-checkbox>
            </b-col>
            <b-col>
              <b-form-checkbox  name="checkbox" @change.native="changeColumns('agentReferenceNo', 'agent_reference_no', $event.target.checked)">
                {{ $t('patentTransactionReportDetail.agent_reference_no') }}
              </b-form-checkbox>
          </b-col>
          </b-row>
          <!--Row 2-->
        <b-row>
          <b-col>
              <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('applicationNo', 'application_no', $event.target.checked)">
                {{ $t('patentTransactionReportDetail.application_no') }}
              </b-form-checkbox>
            </b-col>
            <b-col>
              <b-form-checkbox name="checkbox" @change.native="changeColumns('applicationDate', 'application_date', $event.target.checked)">
                {{ $t('patentTransactionReportDetail.application_date') }}
              </b-form-checkbox>
            </b-col>

            <b-col>
            <b-form-checkbox name="checkbox" @change.native="changeColumns('patentNo', 'patent_no', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.patent_no') }}
            </b-form-checkbox>
          </b-col>

          <b-col>
            <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('dateOfGrant', 'date_of_grant', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.date_of_grant') }}
            </b-form-checkbox>
          </b-col>

          <b-col>
            <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('patentHistory.patentStatus', 'patent_status', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.patent_status') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox name="checkbox" @change.native="changeColumns('patentHistory.date', 'patent_history_date', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.patent_history_date') }}
            </b-form-checkbox>
          </b-col>
        </b-row>

        <!--Row 3-->
        <b-row>
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('ipcCode', 'ipc_code', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.ipc_code') }}
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('note', 'note', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.note') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('dateOfGrantNotification', 'date_of_grant_notification', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.date_of_grant_notification') }}
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('deadlineForPaymentOfGrantFees', 'deadline_for_payment_of_grant_fees', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.deadline_for_payment_of_grant_fees') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('deadline', 'deadline', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.deadline') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('provisionalApplicationDate', 'provisional_application_date', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.provisional_application_date') }}
            </b-form-checkbox>
          </b-col>
        </b-row>

        <!--Row 4-->
        <b-row>
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('dateOfWorkingDeclaration', 'date_of_working_declaration', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.date_of_working_declaration') }}
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('workingDeclarationDeadline', 'working_declaration_deadline', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.working_declaration_deadline') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('b2FilingDate', 'b2_filing_date', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.b2_filing_date') }}
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('b3FilingDate', 'b3_filing_date', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.b3_filing_date') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('epB2PubDate', 'ep_b2_pub_date', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.ep_b2_pub_date') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('epB3PubDate', 'ep_b3_pub_date', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.ep_b3_pub_date') }}
            </b-form-checkbox>
          </b-col>
        </b-row>

        <!--Row 5-->
        <b-row>
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('epPatentNo', 'ep_patent_no', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.ep_patent_no') }}
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('epApplicationNo', 'ep_application_no', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.ep_application_no') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('epApplicationDate', 'ep_application_date', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.ep_application_date') }}
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('epPublicationNo', 'ep_publication_no', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.ep_publication_no') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('epPublicationDate', 'ep_publication_date', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.ep_publication_date') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('translator', 'translator', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.translator') }}
            </b-form-checkbox>
          </b-col>
        </b-row>

        <!--Row 6-->
        <b-row>

          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('pctApplicationNo', 'pct_application_no', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.pct_application_no') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('pctApplicationDate', 'pct_application_date', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.pct_application_date') }}
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('agentAddress.country', 'agent_address_country', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.agent_address_country') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('agentAddress.countryCode', 'agent_address_country_code', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.agent_address_country_code') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('agentAddress.address', 'agent_address_address', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.agent_address_address') }}
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('agentResponsible.email', 'agent_responsible_email', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.agent_responsible_email') }}
            </b-form-checkbox>
          </b-col>
        </b-row>

        <!--Row 7-->
      <b-row>
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('ownerAddress.country', 'owner_address_country', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.owner_address_country') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('ownerAddress.countryCode', 'owner_address_country_code', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.owner_address_country_code') }}
            </b-form-checkbox>
          </b-col>  
          <b-col>
            <b-form-checkbox  name="checkbox" @change.native="changeColumns('ownerAddress.address', 'owner_address_address', $event.target.checked)">
              {{ $t('patentTransactionReportDetail.owner_address_address') }}
            </b-form-checkbox>
          </b-col>
          <b-col>
          </b-col>
          <b-col>
          </b-col>
          <b-col>
            <div class="d-flex align-items-right">
            <b-button class="d-inline-block mr-05" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
          </div>
          </b-col>
        </b-row>
      
        </div>
        
        <!-- table -->
      <vue-good-table
        id="patentTransactionReportDetailTable"
        ref="patentTransactionReportDetailTable" 
        :columns="columns"
        :rows="rows"
        styleClass="vgt-table condensed tableSize"
        :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }" 
        :search-options="{
          enabled: true,
          externalQuery: searchTerm }"
        :pagination-options="{
          enabled: true,
          perPage:pageLength
        }"
      >
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">

        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'recordNo'">
                <b-row >
                    <b-col class="font-size: x-small">  
                      <b-badge @contextmenu.prevent="openContextMenu($event, props.row.recordNo)" @click="showpatentInfoForm(props.row)" variant="primary" style="cursor: pointer;">
                        <feather-icon icon="MousePointerIcon" class="mr-25" />
                        <span>{{ props.row.recordNo }}</span>
                      </b-badge>                     
                    </b-col>
                </b-row>
            </span>
          </template>
     <!-- pagination -->
     <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
            </span>
            <b-form-select v-model="pageLength" :options="['10', '50', '100', '1000']" class="mx-1"
              @input="(value) => props.perPageChanged({ currentPerPage: value })" />
            <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
          </div>
          <div>
            <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number
              align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
      </vue-good-table>
    </b-modal>
    </div>
  </template>
  
  <script>

  export default {
    data() {
      return {
        total: 0,
        pageLength: 50,
        dir: false,
        pageNo: 1,
        columns: [],
        rows: [],
        searchTerm: '',
        isAgent:false,
        isOwner:false,
        name:''
      }
    },
    methods: {
      openContextMenu(event, row) {
            this.$refs.copyMenu.openContextMenu(event, row)
        },
      changeColumns(fieldName, labelName, status){
        if(status)
        {
          if(fieldName.indexOf("Date") > -1 || fieldName.indexOf("date") > -1 || fieldName.indexOf("eadline") > -1){
            var item = {
              label: this.$t('patentTransactionReportDetail.XXX'.replace("XXX", labelName)),
              field: fieldName,
              formatFn: this.$formatFn
            }
          this.columns.push(item);
          }
          else{
            var item = {
              label: this.$t('patentTransactionReportDetail.XXX'.replace("XXX", labelName)),
              field: fieldName,
            }
          this.columns.push(item);
          }

        }
        else
        {
          const index = this.columns.findIndex(i => i.field === fieldName)
          this.columns.splice(index, 1);
        }
      },
      showpatentInfoForm(row){
          this.$bvModal.show('patentForm')
          this.$refs.patentForm.showInfo(row.id)
      },
      showData(data) {
        this.columns = [
          {
            label: this.$t('patentTransactionReportDetail.record_no'),
            field: 'recordNo',
          },
          {
            label: this.$t('patentTransactionReportDetail.title'),
            field: 'title',
          },
          {
            label: this.$t('patentTransactionReportDetail.title_en'),
            field: 'titleEn',
          },
          {
            label: this.$t('patentTransactionReportDetail.agent'),
            field: 'agent',
          },          
          {
            label: this.$t('patentTransactionReportDetail.owner'),
            field: 'owner',
          },
          {
            label: this.$t('patentTransactionReportDetail.application_no'),
            field: 'applicationNo',
          },
          {
            label: this.$t('patentTransactionReportDetail.date_of_grant'),
            field: 'dateOfGrant',
            formatFn: this.$formatFn
          },
          {
            label: this.$t('patentTransactionReportDetail.patent_status'),
            field: 'patentHistory.patentStatus',
          }
        ]
        this.$refs.patentTransactionReportDetailModal.show()
        this.rows = data
      },
      exportExcel() {
        var controller = {
            name: 'Patent',
            actionName: 'CanExport'
        }

        var data = {
            columnList: this.columns,
            dataList: this.rows
        }
        var payload = {
            data: data,
            controller: controller
        }
        let loader = this.$loading.show()
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
            if (response.data.resultStatus == true) {
                this.$downloadFile("Patent Listesi", response.data.base64, 'xlsx')
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
            loader.hide()
        })
      }      
    },
  }
  </script>
<style>
   .tableSize {
    font-size: 13px!important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
  